module.exports = __webpack_public_path__ + "ttf/OpenSans-CondBold-webfont.95d765.ttf";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/assets/fonts/OpenSans-CondBold-webfont.ttf
 ** module id = 323
 ** module chunks = 12
 **/